module.exports = __webpack_public_path__ + "img/cb2-r-b1.d40f8487.gif";